import React from 'react';

const NewZealand = (props: { width: number }) => {
  return (
    <svg viewBox="0 0 1200 600" {...props}>
      <defs>
        <clipPath id="newZealand_Canton">
          <path d="M 0,0 L 600,0 L 600,300 L 0,300 z" />
        </clipPath>

        <clipPath id="newZealand_Diagonals">
          <path d="M 0,0 L 300,150 L 0,150 z M 300,0 L 600,0 L 300,150 z M 300,150 L 600,150 L 600,300 z M 300,150 L 300,300 L 0,300 z" />
        </clipPath>

        <g id="newZealand_Pentagram">
          <g id="newZealand_Arm" transform="translate(0,-0.324925)">
            <path d="M 0,0 L 0,0.5 L 1,0 z" />
            <path d="M 0,0 L 0,-0.5 L 1,0 z" transform="rotate(-36,1,0)" />
          </g>
          <use transform="scale(-1,1)" xlinkHref="#newZealand_Arm" />
          <use transform="rotate(72,0,0)" xlinkHref="#newZealand_Arm" />
          <use transform="rotate(-72,0,0)" xlinkHref="#newZealand_Arm" />
          <use
            transform="rotate(-72,0,0) scale(-1,1)"
            xlinkHref="#newZealand_Arm"
          />
        </g>
      </defs>

      <rect fill="#00247d" height="600" width="1200" x="0" y="0" />

      <g id="newZealand_Flag_of_the_United_Kingdom">
        <path
          clipPath="url(#newZealand_Canton)"
          d="M 0,0 L 600,300 M 0,300 L 600,0"
          id="newZealand_Saint_Andrews_Cross"
          stroke="#ffffff"
          strokeWidth="60"
        />
        <path
          clipPath="url(#newZealand_Diagonals)"
          d="M 0,0 L 600,300 M 0,300 L 600,0"
          id="newZealand_Saint_Patricks_Cross"
          stroke="#cc142b"
          strokeWidth="40"
        />
        <g id="newZealand_Saint_Georges_Cross">
          <path
            clipPath="url(#newZealand_Canton)"
            d="M 300,0 L 300,300 M 0,150 L 600,150"
            stroke="#ffffff"
            strokeWidth="100"
          />
          <path
            clipPath="url(#newZealand_Canton)"
            d="M 300,0 L 300,300 M 0,150 L 600,150"
            stroke="#cc142b"
            strokeWidth="60"
          />
        </g>
      </g>

      <g id="newZealand_Southern_Cross">
        <g id="newZealand_Gamma_Crucis">
          <use
            fill="#ffffff"
            transform="translate(900,120) scale(45.4)"
            xlinkHref="#newZealand_Pentagram"
          />
          <use
            fill="#cc142b"
            transform="translate(900,120) scale(30)"
            xlinkHref="#newZealand_Pentagram"
          />
        </g>
        <g transform="rotate(82,900,240)">
          <g id="newZealand_Delta_Crucis">
            <use
              fill="#ffffff"
              transform="translate(900,120) rotate(-82) scale(40.4)"
              xlinkHref="#newZealand_Pentagram"
            />
            <use
              fill="#cc142b"
              transform="translate(900,120) rotate(-82) scale(25)"
              xlinkHref="#newZealand_Pentagram"
            />
          </g>
          <g id="newZealand_Beta_Crucis">
            <use
              fill="#ffffff"
              transform="translate(900,380) rotate(-82) scale(45.4)"
              xlinkHref="#newZealand_Pentagram"
            />
            <use
              fill="#cc142b"
              transform="translate(900,380) rotate(-82) scale(30)"
              xlinkHref="#newZealand_Pentagram"
            />
          </g>
        </g>
        <g id="newZealand_Alpha_Crucis">
          <use
            fill="#ffffff"
            transform="translate(900,480) scale(50.4)"
            xlinkHref="#newZealand_Pentagram"
          />
          <use
            fill="#cc142b"
            transform="translate(900,480) scale(35)"
            xlinkHref="#newZealand_Pentagram"
          />
        </g>
      </g>
    </svg>
  );
};

export default NewZealand;
